import { TableSchema } from '../metadata-schema';

export const dim_ov_onderwijspositie_vergelijkgroep: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_ov_onderwijspositie_vergelijkgroep",
	"description": "Definitie voor dimension tabel dim_ov_onderwijspositie_vergelijkgroep uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"ov_co_brinvest": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"ov_nm_vergelijkgroep": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"ov_nr_peiljaar": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		}
	}
};
